export namespace PaymentCollectionConstants {
  export const PAYMENT_ACCOUNT: string = 'PAYMENT_ACCOUNT';
  export const FARE_COLLECTION: string = 'FARE_COLLECTION';
}
